import React from 'react';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo el material después de comprar?',
    a: 'En menos de 5 minutos recibís un mail con el link de descarga directo. Si no llega, revisá SPAM o escribinos a soporte@impulsodigitalstore.com'
  }, {
    q: '¿Necesito hacer ejercicio o ir al gimnasio?',
    a: 'No. El MegaPack es 100% alimentación. Si querés sumar movimiento, el Quema x2 incluye rutinas en casa de 15 minutos sin equipamiento.'
  }, {
    q: '¿Funciona si tengo más de 50 o 60 años?',
    a: 'Sí. El método fue diseñado específicamente para el metabolismo de la menopausia, que aplica a mujeres de 40, 50 y 60 años.'
  }, {
    q: '¿Es un pago único o una suscripción?',
    a: 'Pago único. Pagás una sola vez y el contenido es tuyo para siempre. Sin cuotas mensuales ni renovaciones.'
  }, {
    q: '¿La garantía es real?',
    a: 'Completamente real. Si en 7 días no estás conforme, te reintegramos el 100% del dinero, sin formularios ni explicaciones. Tasa de devoluciones: menos del 1%.'
  }, {
    q: '¿Puedo participar si tengo restricciones alimentarias?',
    a: 'Sí. El método incluye variantes para celíacas, intolerantes a la lactosa y quienes no comen carne.'
  }];
  return <div className="bg-brand-ink py-16 px-6" data-id="element-123">
      <div className="max-w-[960px] mx-auto" data-id="element-124">
        <span className="block text-[11px] font-bold tracking-[3px] uppercase text-brand-green text-center mb-2.5" data-id="element-125">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </span>
        <h2 className="font-display text-[22px] sm:text-[3.5vw] md:text-[38px] text-center text-white mb-9 uppercase" data-id="element-126">
          Preguntas frecuentes
        </h2>

        <div className="max-w-[680px] mx-auto" data-id="element-127">
          {faqs.map((faq, i) => <div key={i} className="border-b border-brand-border py-5" data-id="element-128">
              <p className="font-display text-[17px] text-white mb-2 uppercase" data-id="element-129">
                <span className="text-brand-green mr-2.5" data-id="element-130">✦</span>
                {faq.q}
              </p>
              <p className="text-[13px] text-brand-muted leading-[1.6]" data-id="element-131">
                {faq.a}
              </p>
            </div>)}
        </div>
      </div>
    </div>;
}